var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeviceBeltLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    enableBackground: "new 0 0 60 60",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M19.5,35.5c0-1.5,0.2-2.9,0.6-4.2l2.6-9.6l6.2-3.1v-1.7v-0.1c-1.3-0.9-2.1-2.6-2.1-4.5 C26.8,9.4,28.6,7,31,7c2.4,0,4.3,2.4,4.3,5.3c0,1.9-0.9,3.7-2.3,4.6v1.7l1.3,0.6l0.4,0.2L19.5,35.7l0.1,2.1c0,0,0,0.8,0,0.8 l0.6,3.3c3.5-1.4,7.1-2.1,10.7-2.1c3.7,0,7.1,0.7,10.5,2.1l0,0l0.3-1.3l0.2-1.2c-3.5-1.4-7.3-2.2-11.1-2.2c-2.9,0-5.8,0.4-8.6,1.3 v-0.1L22,36.8l15.3-15.9l0.1-0.1l1.9,0.9l2.4,9.6l0,0c0.5,2.2,0.6,4.8,0.3,7.4c-0.2,2.1-0.8,4.2-1.5,6l-4.1,9.4l-4.3,0.7l4.8-11.5 l-0.1,0.1c-1.7-0.5-3.7-0.8-5.7-0.8c-2.2,0-4.4,0.3-6.2,0.9l4.6,11.3l-4.1-0.7l-4.2-9.2l0-0.1c-0.7-1.8-1.2-3.7-1.6-6.4 C19.5,36.7,19.5,36.6,19.5,35.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "black",
    points: "43.9,14.3 41.7,12.3 34.7,19.5 37.4,21 43.9,14.5  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13.2,46.4c2.2-1.9,4.6-3.4,7.2-4.5l0,0l-0.5-3.2l-0.2-3.1l-8.4,8.9L13.2,46.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M48.7,46.4c-2.2-1.9-4.6-3.4-7.2-4.5l0,0l0.2-1.4l0.2-1.2c3.1,1.3,6,3.1,8.6,5.4l0.1-0.1L48.7,46.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceBeltLight);
export default __webpack_public_path__ + "static/media/device-belt-light.10d4354111a879621367acc3b4758e96.svg";
export { ForwardRef as ReactComponent };